import React from "react";
import complete from '../../assets/img/complete.png'
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import withAuth from "../../auth/UserRouteAuth";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserPickupRequestComplPg() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();

    const moveToMainPg = (() => {
        navigate("/")
    })

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-result-wrap">
                <div className="up-result">
                    <img className="up-result-icon" src={complete} alt="complete"/>
                    <p className="up-result-title">{t('upr18')}</p>
                    <span className="up-result-sub">{t('upr19')}</span>
                    <div className="up-btn-row" style={{justifyContent: "center", marginTop: "24px"}}>
                        <button className="up-btn-primary" style={{height: "50px", fontSize: "16px", maxWidth: "200px", margin: "0 auto"}}
                                onClick={moveToMainPg}>
                            {t('umscBt')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withAuth(UserPickupRequestComplPg)
